/**
 * Submit form on checked
 * @author Zeno Jiricek
 */

// Utilities
import debug from "debug";
const MODULE_NAME = 'core/modules/forms/submits-on-changed';
const log = debug(MODULE_NAME);

const ATTR = 'data-submits-on-changed';
const SELECTOR = `[${ATTR}]`;
const LOADINGPANEL = '.product-index__loading-panel';
const FORM_ATTR = 'data-submits-on-changed-form';
const PASS_VALUE_TO_ATTR = 'data-submits-on-changed-pass-value-to';

export default function () {
     $(document).ready(() => {
        const $selectField = $(SELECTOR);
        const $loading = $(LOADINGPANEL);


        $selectField.show();
        log('binding submit-on-change to', $selectField);

        $selectField
            .on('change', function onChanged () {
                const $this = $(this);

                var form = $this.attr(FORM_ATTR);
                const $form = $(form);

        		var passValueTo = $this.attr(PASS_VALUE_TO_ATTR);
        		const $passValueToEl = $(passValueTo);

                if ($passValueToEl.length > 0) {
                	$passValueToEl.val($this.val());
                	$passValueToEl.trigger('change');
                }
                else {
	                if ($loading.length >0) {
	                    $loading.addClass('active');

	                    setTimeout(function(){
	                        log($this, 'changed. submitting', $form);
	                        $form.submit();
	                    }, 200);
	                }
	                else {
	                    log($this, 'changed. submitting', $form);
	                    $form.submit();
	                }
	            }

            });
    });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/forms/submits-on-changed.js